import useCustomApi from '../../hooks/use-custom-api'
import {useQuery} from '@tanstack/react-query'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

export const useGetCategoriesData = () => {
    const {site, locale} = useMultiSite()

    const api = useCustomApi()
    const countryCode = locale?.id.replace('-', '_') || 'en'

    const {data: categoriesData} = useQuery(
        ['categoriesData', locale?.alias],
        async () => {
            const localeCode = countryCode || 'en'
            let categoriesMenuDataKey = 'categoriesMenuData_' + localeCode

            if (site?.id.indexOf('delonghi') == -1) {
                categoriesMenuDataKey += '_' + site.id
            }

            // even though it says menu data, it's actually all the categories data
            const data = await api.getCustomObject('categoriesMenuData', categoriesMenuDataKey)

            if (data?.c_categoriesData) {
                const parsedData = JSON.parse(data?.c_categoriesData)
                Object.keys(parsedData).forEach((key) => {
                    // Remap name to displayName
                    if (parsedData[key].name) {
                        parsedData[key].displayName = parsedData[key].name
                        delete parsedData[key].name
                    }
                })
                return parsedData
            }

            return null
        },
        {staleTime: Infinity},
    )

    return categoriesData
}
